import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import Modal from 'react-modal';

import useModalStore from "../../store/useModalStore";
import FormButtonSecondary from "../form/FormButtonSecondary";
import FormButtonPrimary from "../form/FormButtonPrimary";
import FormButtonDanger from "../form/FormButtonDanger";
import FormButton from "../form/FormButton";
import Space from "../core/Space";

const ModalConfirm = ({ children }) => {
    const {
        isModalConfirmOpen,
        closeModalConfirm,
        modalConfirmTitle,
        modalConfirmText,
        modalConfirmContent,
        confirmCallback,
        cancelCallback,
        shouldCloseOnOverlayClick,
        modalConfirmPrimaryButtonText,
        modalConfirmPrimaryButtonDisabled,
        modalConfirmPrimaryButtonStyleChangeToDanger,
        modalConfirmSecondaryButtonText,
        modalConfirmCloseManually,
        modalConfirmStyle,
    } = useModalStore();

    const modalConfirmRef = useRef(null);

    useEffect(() => {
        if (modalConfirmRef.current) {
            modalConfirmRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);

    return (
        <Modal
            // For open timeout, please find in index.css
            portalRef={modalConfirmRef}
            closeTimeoutMS={250}
            isOpen={isModalConfirmOpen}
            onRequestClose={closeModalConfirm}
            style={{
                content: { ...customStyles.content, ...modalConfirmStyle.content },
                overlay: { ...customStyles.overlay, ...modalConfirmStyle.overlay },
            }}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        >
            {
                modalConfirmTitle && <ModalTitle>{modalConfirmTitle}</ModalTitle>
            }

            {
                modalConfirmText && <ModalText>{modalConfirmText}</ModalText>
            }

            {modalConfirmContent}

            <Space height={48} />

            <ModalButtonRow>
                <FormButtonSecondary size={"small"} onClick={() => {
                    closeModalConfirm();

                    if (cancelCallback) {
                        cancelCallback();
                    }
                }}>
                    {modalConfirmSecondaryButtonText}
                </FormButtonSecondary>

                {
                    modalConfirmPrimaryButtonStyleChangeToDanger ?
                        <FormButtonDanger disabled={modalConfirmPrimaryButtonDisabled} size={"small"} onClick={modalConfirmPrimaryButtonDisabled ? null : () => {
                            if (!modalConfirmCloseManually) closeModalConfirm();
                            if (confirmCallback) confirmCallback();
                        }}>
                            {modalConfirmPrimaryButtonText}
                        </FormButtonDanger>
                        :
                        <FormButtonPrimary disabled={modalConfirmPrimaryButtonDisabled} size={"small"} onClick={modalConfirmPrimaryButtonDisabled ? null : () => {
                            if (!modalConfirmCloseManually) closeModalConfirm();
                            if (confirmCallback) confirmCallback();
                        }}>
                            {modalConfirmPrimaryButtonText}
                        </FormButtonPrimary>
                }
            </ModalButtonRow>

            <CloseButton onClick={() => {
                closeModalConfirm();
            }}>
                <CloseImg src={`${process.env.PUBLIC_URL}/images/close.svg`} alt="close" />
            </CloseButton>
        </Modal>
    );
};

const customStyles = {
    overlay: {
        background: 'rgba(0, 0, 0, 0.3)',
        zIndex: 900,
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        padding: 32,
        borderRadius: 8,
        maxHeight: '95vh',
        maxWidth: '95vw',
    },
};

const ModalTitle = styled.div`
  font-size: 20px;
  line-height: 30px;
  font-weight: bold;
  color: var(--aia-bx-dark-blue);
  margin-bottom: 16px;
`;

const ModalText = styled.div`
  font-size: 16px;
  line-height: 26px;
  color: var(--aia-bx-black);
`;

const ModalButtonRow = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
`;

const CloseButton = styled(FormButton)`
  position: absolute;
  top: 16px;
  right: 16px;
`;

const CloseImg = styled.img`
  width: 30px;
  height: 30px;
`;

export default ModalConfirm;